import { LegalDocument } from '../../components/legal/LegalDocument';
import { termsAndroidContent } from '../../content/legal/termsAndroidContent';

export function AndroidTerms() {
  return (
    <LegalDocument
      content={termsAndroidContent}
      platform="android"
      seoDescription="LuvLust Android Terms and Conditions. One-time purchase terms for the couples app."
      seoKeywords="luvlust android terms, in-app purchase terms, play store terms"
    />
  );
}
